import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import AppBar from '../components/AppBar';
import Toolbar from '../components/Toolbar';
import { getUserCurrentlyAuthenticated } from '../components/authentication';
import { useLocation } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { Menu, MenuOpen } from "@mui/icons-material";
import watch from "../components/img/watch.png";

const rightLink = {
  fontSize: 16,
  color: 'common.white',
  ml: 3,
};

function AppAppBar({ open, setOpen }) {
  const location = useLocation();
  
  const [user, setUser] = React.useState("");

  React.useEffect(() => {
    getUserCurrentlyAuthenticated()
      .then((user) => {
        setUser(user.attributes.email);
      })
      .catch((reason) => {
        setUser("");
      }
  )}, [])

  const handleClick = () => {
    setOpen(prevOpen => !prevOpen);
  }

  const WatchIcon = () => (
    <Box
      component="img"
      src={watch}
      alt="watch icon"
      sx={{
        position: 'absolute',
        top: 12,
        left: 10,
        right: 0,
        bottom: 0,
        height: '65%',
        width: 'auto',
      }}
    />
  );

  const DynamicMenuIcon = () => (
    <Box 
      alt="menu icon"
      sx={{ 
        position: 'absolute',
        top: -1,
        left: 8,
        right: 0,
        bottom: 0,
        height: '0%',
      }}
    >
        <IconButton color="secondary" size='large' onClick={handleClick}>
          {open ? 
            <MenuOpen style={{ fontSize: '150%' }} /> : <Menu sx={{ fontSize: '150%' }} />}
        </IconButton>
      </Box>
  );

  const isOnDashboard = () => {
    return location.pathname.includes("dashboard");
  }

  return (
    <div>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start', height: '100%' }} >
            {open === undefined ? <WatchIcon /> : <DynamicMenuIcon />}
          </Box>
          <Link
            variant="h6"
            underline="none"
            color="inherit"
            href="/"
            sx={{ fontSize: 24 }}
          >
            Watch Exchanger
          </Link>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            {user === "" &&
              <Link
                color="inherit"
                variant="h6"
                underline="none"
                href="/sign-in"
                sx={{ ...rightLink, color: 'secondary.main' }}
              >
                {'Sign In'}
              </Link>
            }
            {user !== "" && isOnDashboard() && 
              <Link
                variant="h6"
                underline="none"
                href="/sign-out"
                sx={{ ...rightLink, color: 'secondary.main' }}
              >
                {'Sign Out'}
              </Link>
            }
            {!isOnDashboard() && user !== "" &&
              <Link
                variant="h6"
                underline="none"
                href="/dashboard"
                sx={{ ...rightLink, color: 'secondary.main' }}
              >
                {'Sign In'}
              </Link>
            }
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

export default AppAppBar;